<script lang="ts" setup>
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/es'
import 'dayjs/locale/en'
import 'dayjs/locale/ca'

const { locale, t } = useI18n()

dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.locale(locale.value)

watch(locale, () => {
  dayjs.locale(locale.value)
})

import { CModal, CModalHeader, CModalTitle, CModalBody, CButton } from '@coreui/vue-pro'
import { IconRefresh, IconLogout } from '@tabler/icons-vue'

const refreshIntervalId = ref(null)
const realTimeEnd = ref()
const humanRealTimeEnd = ref()

const MODALNCookieExpires = ref(false)
const us = useUserStore()
const mounted = ref(false)

const sessionLifeTime = import.meta.env.VITE_SESSION_LIFETIME

onMounted(() => {
  // console.log('CookieCountDown',)
  const startAt = dayjs()
  const endAt = startAt.add(sessionLifeTime, 'minutes')
  refreshIntervalId.value = setInterval(() => {
    const time = dayjs.duration(endAt.diff(dayjs()))
    realTimeEnd.value = dayjs.utc(time.asMilliseconds()).format('mm:ss')
    const [minutes] = realTimeEnd.value.split(':').map(Number)
    humanRealTimeEnd.value = dayjs.duration(minutes, 'minutes').humanize()
    if (realTimeEnd.value == '01:30') MODALNCookieExpires.value = true
    if (realTimeEnd.value == '00:00') us.doLogout()
  }, 500)
  setTimeout(() => {
    mounted.value = true
  }, 5000)
})

onUnmounted(() => {
  clearInterval(refreshIntervalId.value)
})

async function refreshCookie() {
  await us.userAuthCheck()
  MODALNCookieExpires.value = false
}

function logOut() {
  us.doLogout()
  MODALNCookieExpires.value = false
}
</script>

<template>
  <teleport to=".cookie-counter" v-if="mounted">
    <div class="ms-3">{{ t('Session') }}: {{ humanRealTimeEnd }}</div>
  </teleport>
  <CModal backdrop="static" :visible="MODALNCookieExpires" @close="MODALNCookieExpires = false">
    <CModalHeader>
      <CModalTitle>{{ t('The session will expire in') }} {{ realTimeEnd }}</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div>
        {{ t('The page must have activity for the session not to expire') }}.
        <br />
        <br />
      </div>
      <CButton @click="refreshCookie" color="info" size="sm" class="me-3">
        <IconRefresh stroke-width=".8" size="27" />
        <span>{{ t('Refresh session') }}</span>
      </CButton>
      <CButton @click="logOut" color="danger" size="sm">
        <IconLogout stroke-width=".8" size="27" />
        <span>{{ t('Log out') }}</span>
      </CButton>
    </CModalBody>
  </CModal>
</template>
